import { useAuthSessionStore } from '@/store/authSessionStore'
import { useBackendThreadListSync } from './useBackendThreadListSync'
import { useBackendThreadMessagesSync } from './useBackendThreadMessagesSync'

/** @param {object} m */
export function useBackendChatSync(m) {
  const accessToken = useAuthSessionStore((state) => state.accessToken)
  useBackendThreadListSync(m, accessToken)
  useBackendThreadMessagesSync(m, accessToken)
}
